/* unplugin-vue-components disabled */import script from "./YEmpty.vue?vue&type=script&lang=tsx"
export * from "./YEmpty.vue?vue&type=script&lang=tsx"

const cssModules = {}
import style0 from "./YEmpty.vue?vue&type=style&index=0&id=656bfab2&lang=postcss&module=css"
cssModules["css"] = style0

import exportComponent from "/root/workspace/njyx-frontend-pc_5kTN/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47_webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__